
import React, { useState } from 'react';
import MaterialTable from '@material-table/core';
import tableIcons from './tableIcons';
import ExportToExcel from '../../ExportToExcel.js'
import { AiFillFileExcel } from "react-icons/ai";


//parameters to table component

const Table = ({columns,tableId, data,onRowClick, parentChildData, rowsPerPage,  selectedGlobalObjectKey, rowColoring,className }) => {

 
    return (
        <MaterialTable
            
            key={tableId}
            id={tableId}
            columns={columns}
            data={data}
            parentChildData={parentChildData}     
            onRowClick={onRowClick}    
            icons={tableIcons}          
            actions={[
                {
                    icon: AiFillFileExcel,
                    tooltip: "Export to Excel",
                    isFreeAction: true,
                    onClick: () => {
                        ExportToExcel(data, 'ExportToExcel', className);
                    }
                }
            ]}
            options={{        
                    showTitle: false,
                    pageSize: rowsPerPage,
                    pageSizeOptions: [10, 20, 50, 100, 1000, { value: data.length > 0 ? data.length : 1, label: 'All' }],
                    minBodyHeight: "60vh",
                    maxBodyHeight: "60vh",                  
                    columnsButton: true,
                    filtering: true,
                    emptyRowsWhenPaging: false,
                    rowStyle: (rowData) => ({
                        height: "12px",                        
                        backgroundColor:
                            rowColoring && rowData.specifications?.GlobalObjectKEY === selectedGlobalObjectKey ? "#ffc107" : null,
                    }),
                    hover: {
                        backgroundColor: 'green',
                    },
                    headerStyle: {
                        backgroundColor: '#0075BE',                    
                        color: "#FFF", position: 'sticky',
                        top: 0,
                        height: "15",                        
                        whiteSpace: 'nowrap' 
                    },     
                    filterRowStyle: {
                        position: "sticky",                   
                        background: "white",
                        top: 25,
                        height:"25",
                     
                    }
                }}
            />  
    )
}
export default Table;
